import { BillingSvg } from 'assets/icons/billing';
import { Icons } from 'assets/icons/icons.index';
import { TireSvg } from 'assets/icons/tire';
import { ItemMenuList } from 'components';
import { isEmailAllowed } from 'constants/delete-user.constants';
import { useAllowedDeleteUserEmails } from 'hooks/useAllowedDeleteUserEmails';
import { useDataStoreFlags } from 'hooks/useDataStoreFlags';
import { IAppReducer } from 'models/reducer.interface';
import { useSelector } from 'react-redux';
import './Menu-list.scss';

export const MenuList = () => {
  const user = useSelector((state: IAppReducer) => state.authReducer);
  const { allowedEmails, isLoading } = useAllowedDeleteUserEmails();
  const { flags, isLoading: flagsLoading } = useDataStoreFlags();

  return (
    <nav className="menu__list">
      <ItemMenuList
        label="Mi perfil"
        link={'/settings/profile'}
        icon={Icons.profile}
        id="option-profile"
        subTitle="Actualiza aquí tus datos personales"
      />
      <ItemMenuList
        label="Mis Propiedades"
        active={true}
        link={'/settings/properties'}
        icon={Icons.properties}
        id="option-properties"
        subTitle="Tus autos, hogares y mascotas"
      />
      {user.agentAuthData?.role === 'customer service' && (
        <ItemMenuList
          label="Suscripciones"
          link={'/settings/subscriptions'}
          icon={<TireSvg color="primary" className="menu__list__icon" />}
          id="option-payments"
          subTitle="Administra tus suscripciones"
        />
      )}
      <ItemMenuList
        label="Pagos y planes"
        link={'/settings/payments'}
        icon={<BillingSvg color="primary" className="menu__list__icon" />}
        id="option-payments"
        subTitle="Actualiza tus planes y ve tu facturación"
      />
      {/* <ItemMenuList
        label="Historial de Servicios"
        link={'/settings/services-history'}
        icon={<HistorySvg color="primary" className="menu__list__icon" />}
        id="option-history"
        subTitle="Revisa el historial de tus servicios"
      /> */}
      {user.role === 'customer service' && (
        <ItemMenuList
          label="UserImpersonation"
          link={'/sales'}
          icon={Icons.contactCenter}
          id="option-agent"
          subTitle="Acceso a suscripciones de clientes"
        />
      )}
      {user.role === 'customer service' &&
        !flagsLoading &&
        flags?.massivePaymentLinks === true &&
        isEmailAllowed(user.email, allowedEmails) && (
          <ItemMenuList
            label="Vender seguro masivo (identificadores)"
            link={'/settings/sell-insurance-massively-identifier'}
            icon={Icons.contactCenter}
            id="option-sell-insurance-massively-identifier"
            subTitle="Generar links de pago por identificadores"
          />
        )}
      {user.role === 'customer service' && (
        <ItemMenuList
          label="Buscar usuario"
          link={'/settings/search-user'}
          icon={Icons.search}
          id="option-search-user"
          subTitle="Buscar usuario"
          customStyle="search-user"
        />
      )}
      {user.role === 'customer service' &&
        !isLoading &&
        isEmailAllowed(user.email, allowedEmails) && (
          <ItemMenuList
            label="Borrar usuario"
            link={'/settings/delete-user'}
            icon={Icons.contactCenter}
            id="option-delete-user"
            subTitle="Borrar usuario"
          />
        )}
    </nav>
  );
};
